import { responsiveFontSizes, ThemeOptions } from "@mui/material"
import { grey } from '@mui/material/colors';

import { AppSettings } from './AppSettings';
import * as Dtos from './api/dtos';
import { FormDefinitionCollectionResponse, FormsFeature, GetFormMetadataResponse, IUserResponse } from '@ngt/forms';

const createFormsFeature = (
    user?: IUserResponse, 
    formMetadata?: GetFormMetadataResponse,
    formDefinitions?: FormDefinitionCollectionResponse
) => {
    if (!user || !user.user) {
        global.location.href = `/auth/openiddict?redirect=${encodeURIComponent(global.location.pathname + global.location.search)}`;
    }
    
    if (!formMetadata) {
        throw Error("Form Metadata could not be retrieved!");
    }
    
    if (!formDefinitions) {
        throw Error("Form Definitions could not be retrieved!");
    }
    
    const formsFeature = new FormsFeature({
        baseRoute: AppSettings.formsPath,
        client: {
            baseUrl: AppSettings.client.baseUrl,
            basePath: AppSettings.client.basePath
        },
        dtos: Dtos,
        themeOptions: {
            overrideChosenTheme: AppSettings.palette.overrideTheme,
            beforeThemeCreated: (themeOptions, chosenTheme) => {
                let newOptions: ThemeOptions = {
                    ...themeOptions,
                    palette: {
                        ...themeOptions.palette,
                        primary: {
                            main: chosenTheme === 'dark' ? AppSettings.palette.primaryDark : AppSettings.palette.primaryLight
                        },
                        secondary: {
                            main: chosenTheme === 'dark' ? AppSettings.palette.secondaryDark : AppSettings.palette.secondaryLight 
                        }
                    },
                    // components: {
                    //     MuiTextField: {
                    //         defaultProps: {
                    //             size: 'small',
                    //             margin: 'none'
                    //         }
                    //     },
                    //     MuiSelect: {
                    //         defaultProps: {
                    //             size: 'small'
                    //         }
                    //     },
                    // }
                };

                if (chosenTheme !== 'dark') {
                    if (!newOptions.palette) {
                        newOptions.palette = {}
                    }
            
                    newOptions.palette.background = {
                        default: grey[200]
                    }
                }

                return newOptions;
            },
            afterThemeCreated: (theme: any) => {
                return responsiveFontSizes(theme);
            }
        },
        initialFormMetadata: formMetadata,
        initialAuthentication: user,
        initialFormDefinitions: formDefinitions,
        extensions: []
    });
    
    formsFeature.serviceStackClient.exceptionFilter = (res: Response, _error: any) => {
        if (res.status === 401) {
            global.location.href = `/auth/openiddict?redirect=${encodeURIComponent(global.location.pathname + global.location.search)}`;
        }
    };

    return formsFeature;
}

export default createFormsFeature;